import { Grid, Box } from '@mui/material';
import { MetricCard } from '../ui/MetricCard';
import { TestimonialCarousel } from '../ui/TestimonialCarousel';
import { FadeIn } from '../ui/FadeIn';
import { Metrics, Testimonials, UserType } from '../../lib/social-proof';

interface PricingSocialProofSectionProps {
    userType?: UserType[];
    metricIds: string[];
    bgVariant?: 'transparent' | 'default' | 'paper' | 'gradient' | 'dark';
    showLogos?: boolean;
}

export function PricingSocialProofSection({
    userType,
    metricIds = [],
    bgVariant = 'default',
    showLogos = false
}: PricingSocialProofSectionProps) {

    // Filter Testimonials
    let displayedTestimonials = Testimonials;
    if (userType && userType.length > 0) {
        displayedTestimonials = displayedTestimonials.filter(t =>
            t.userType && t.userType.some(u => userType.includes(u))
        );
    }
    // Sort by order
    displayedTestimonials.sort((a, b) => (a.order || 999) - (b.order || 999));

    // Filter Metrics
    const displayedMetrics = metricIds
        .map(id => Metrics[id])
        .filter(Boolean);

    if (displayedMetrics.length === 0 && displayedTestimonials.length === 0) return null;

    return (
        <Box>
            <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center">
                {/* Left Column: Testimonial Carousel */}
                <Grid item xs={12} md={7}>
                    <FadeIn direction="right">
                        {displayedTestimonials.length > 0 && (
                            <TestimonialCarousel testimonials={displayedTestimonials} showLogos={showLogos} />
                        )}
                    </FadeIn>
                </Grid>

                {/* Right Column: Stacked Metrics */}
                <Grid item xs={12} md={5}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        {displayedMetrics.map((metric, index) => (
                            <FadeIn key={metric.id} direction="left" delay={index * 150}>
                                <MetricCard
                                    tagline={metric.tagline}
                                    value={metric.value}
                                    label={metric.label}
                                    description={metric.description}
                                    align="left"
                                    valueColor={bgVariant === 'dark' ? 'white' : undefined}
                                />
                            </FadeIn>
                        ))}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
